"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridTradingUtils = exports.GridCheckOpenPositionPriceLimit = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
// 获取开单价格的阈值
const GridCheckOpenPositionPriceLimit = (slippageControl, triggerPrice, currentPrice, useAllCoins, trend, symbol) => {
    let open_position_buy_limit = undefined;
    let open_position_sell_limit = undefined;
    const openPrice = triggerPrice || currentPrice;
    if (slippageControl && openPrice && useAllCoins === false) {
        if (trend === "long") {
            const value = new trade_utils_lib_1.SafeDecimal(openPrice).mul(new trade_utils_lib_1.SafeDecimal(slippageControl).add(1));
            open_position_buy_limit = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(value, symbol.precision);
        }
        else {
            const value = new trade_utils_lib_1.SafeDecimal(openPrice).mul(new trade_utils_lib_1.SafeDecimal(1).sub(new trade_utils_lib_1.SafeDecimal(slippageControl)));
            open_position_sell_limit = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(value, symbol.precision);
        }
    }
    return [open_position_buy_limit, open_position_sell_limit];
};
exports.GridCheckOpenPositionPriceLimit = GridCheckOpenPositionPriceLimit;
exports.GridTradingUtils = {
    /// 检测必要的参数是否为空
    checkRequiredParamsEmpty(top, bottom, count) {
        const errors = [];
        if (!Number(bottom)) {
            errors.push("grid_order_low");
        }
        if (!Number(top)) {
            errors.push("grid_order_high");
        }
        if (!Number(count)) {
            errors.push("gird_row_count");
        }
        return errors;
    },
    useInvestAndInvestPercent(investAction, invest, investPercent, totalAvailable, investPrecision) {
        const lastInvest = (0, react_1.useRef)("");
        const lastPercent = (0, react_1.useRef)(0);
        const lastTotal = (0, react_1.useRef)("");
        const lastAction = (0, react_1.useRef)(undefined);
        const lastPrecision = (0, react_1.useRef)(-1);
        const resultInvest = (0, react_1.useRef)("");
        const resultPercent = (0, react_1.useRef)(undefined);
        const updateTextInvest = () => {
            lastInvest.current = invest;
            lastTotal.current = totalAvailable;
            lastPrecision.current = investPrecision;
            let percent = 0;
            if (Number(totalAvailable) > 0) {
                percent = new trade_utils_lib_1.SafeDecimal(invest).div(new trade_utils_lib_1.SafeDecimal(totalAvailable)).toNumber();
                percent = percent > 1 ? 1 : percent;
            }
            resultInvest.current = invest;
            resultPercent.current = percent;
            return [invest, percent];
        };
        if (investAction === "text") {
            if (lastInvest.current !== invest || lastAction.current !== "text" || lastInvest.current !== resultInvest.current) {
                lastAction.current = "text";
                return updateTextInvest();
            }
        }
        if (investAction === "slider") {
            if (lastPercent.current !== investPercent || lastAction.current !== "slider") {
                lastAction.current = investAction;
                lastPercent.current = investPercent;
                const ivst = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(totalAvailable).mul(investPercent), investPrecision);
                const parseInvest = Number(ivst) ? ivst : "";
                resultInvest.current = parseInvest;
                resultPercent.current = investPercent;
                return [resultInvest.current, undefined];
            }
        }
        if (lastTotal.current !== totalAvailable || lastPrecision.current !== investPrecision) {
            return updateTextInvest();
        }
        return [resultInvest.current, resultPercent.current];
    },
    /// 计算单网格利润率
    useProfitPerGrid(gridType, top, bottom, count, fee, maxCount = 1000) {
        return (0, react_1.useMemo)(() => {
            if (new trade_utils_lib_1.SafeDecimal(maxCount).lessThan(new trade_utils_lib_1.SafeDecimal(count))) {
                return;
            }
            const result = (0, trade_utils_lib_1.calcProfitPerGrid)(gridType, top, bottom, count, fee);
            if (!result) {
                return;
            }
            return result.map((profit) => {
                const profitD = new trade_utils_lib_1.SafeDecimal(profit);
                if (profitD.lessThan(0.0001)) {
                    return new trade_utils_lib_1.SafeDecimal(profit).toDecimalPlaces(6).toNumber();
                }
                return new trade_utils_lib_1.SafeDecimal(profit).toDecimalPlaces(4).toNumber();
            });
        }, [gridType, top, bottom, count, fee]);
    },
    ///=> 处理展示单网格利润率
    useProfitPerGridDesc(profitPerGrid) {
        const processProfitDisplay = (0, react_1.useCallback)((profit) => {
            const precision = profit < 0.0001 ? 4 : 2;
            return trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(profit).mul(100), false, true, precision);
        }, []);
        return (0, react_1.useMemo)(() => {
            if (!profitPerGrid) {
                return "";
            }
            if (profitPerGrid.length === 2) {
                const start = processProfitDisplay(profitPerGrid[0]);
                const end = processProfitDisplay(profitPerGrid[1]);
                return `${start}-${end}`;
            }
            else if (profitPerGrid.length === 1) {
                return processProfitDisplay(profitPerGrid[0]);
            }
            return "";
        }, [profitPerGrid]);
    },
    useMinInvest(botType, trend, earnCoin, gridType, top, bottom, count, symbol, market, api, currentPrice, condition, leverage, feeRate, updateSignal, enable = true, maxGrids) {
        const [minInvest, setMinInvest] = (0, react_1.useState)("");
        (0, react_1.useEffect)(() => {
            if (minInvest) {
                setMinInvest("");
            }
            if (!Number(top) || !Number(bottom) || !Number(count) || !earnCoin || !enable) {
                return;
            }
            const maxmaxGridCount = botType === TradeAPILib_1.ExchangeOrderType.gridV3 || botType === TradeAPILib_1.ExchangeOrderType.gridV4 ? maxGrids || 1000 : 150;
            if (new trade_utils_lib_1.SafeDecimal(top).lessThanOrEqualTo(bottom) ||
                new trade_utils_lib_1.SafeDecimal(count).lessThan(2) ||
                new trade_utils_lib_1.SafeDecimal(count).greaterThan(maxmaxGridCount)) {
                return;
            }
            const subscribe = this.checkMinInvest(botType, earnCoin, trend, top, bottom, count, gridType, symbol, market, api, currentPrice, condition, leverage, feeRate).subscribe((result) => {
                setMinInvest(result);
            }, (error) => {
                setMinInvest("");
            });
            return () => {
                subscribe.unsubscribe();
            };
        }, [earnCoin, trend, bottom, market, api, enable, feeRate, top, count, symbol.symbol, gridType, leverage, condition, updateSignal]);
        return minInvest;
    },
    calcuPairInvest(symbol, earnCoin, useAllCoins, investPercent, currentPrice, baseAvailable, quoteAvailable) {
        let baseInvest = "0";
        let quoteInvest = "0";
        if (earnCoin === symbol.base) {
            if (useAllCoins) {
                const total = new trade_utils_lib_1.SafeDecimal(baseAvailable).add(new trade_utils_lib_1.SafeDecimal(quoteAvailable).div(new trade_utils_lib_1.SafeDecimal(currentPrice)));
                const invest = new trade_utils_lib_1.SafeDecimal(investPercent).mul(total);
                if (invest.lessThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(baseAvailable))) {
                    baseInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(invest, symbol.amount);
                }
                else {
                    baseInvest = baseAvailable;
                    const calcuRes = invest
                        .sub(baseAvailable || 0)
                        .mul(currentPrice || 0)
                        .toString();
                    quoteInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(calcuRes, symbol.precision);
                }
            }
            else {
                const value = new trade_utils_lib_1.SafeDecimal(baseAvailable).mul(new trade_utils_lib_1.SafeDecimal(investPercent));
                baseInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(value, symbol.amount);
            }
        }
        else {
            if (useAllCoins) {
                const total = new trade_utils_lib_1.SafeDecimal(quoteAvailable).add(new trade_utils_lib_1.SafeDecimal(baseAvailable).mul(new trade_utils_lib_1.SafeDecimal(currentPrice)));
                const invest = new trade_utils_lib_1.SafeDecimal(investPercent).mul(total);
                if (invest.lessThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(quoteAvailable))) {
                    quoteInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(invest, symbol.precision);
                }
                else {
                    quoteInvest = quoteAvailable;
                    const calcuRes = invest
                        .sub(quoteAvailable || 0)
                        .div(currentPrice || 0)
                        .toString();
                    baseInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(calcuRes, symbol.amount);
                }
            }
            else {
                if (Number(investPercent) > 0) {
                    const value = new trade_utils_lib_1.SafeDecimal(quoteAvailable).mul(new trade_utils_lib_1.SafeDecimal(investPercent));
                    quoteInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(value, symbol.precision);
                }
            }
        }
        return { baseInvest: baseInvest, quoteInvest: quoteInvest };
    },
    /// 获取最小成交额
    checkMinInvest(botType, earn_coin, trend, top, bottom, count, profitCalType, symbol, market, api, open_price, condition, leverage, fee_rate) {
        const condition_direction = this.getConditionDirection(condition, open_price);
        const checkRequest = {
            bu_order_type: botType,
            symbol: symbol,
            base_total_investment: "",
            quote_total_investment: "",
            market: market,
            top: top,
            bottom: bottom,
            row: count,
            earn_coin: earn_coin,
            trend: trend,
            grid_type: profitCalType,
            loss_stop: "",
            profit_stop: "",
            open_price: open_price,
            condition: condition,
            condition_direction: condition_direction,
            leverage: leverage && leverage,
            fee_rate: fee_rate,
        };
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return api.checkGridOrderCanCreate(checkRequest);
        }, {
            maxRetryCount: 3,
            onRetry: (count, message) => {
                console.log(count);
                console.log(message);
            },
        }).pipe((0, operators_1.map)((result) => {
            const isBase = earn_coin === symbol.base;
            const min = isBase ? result.min_base_investment || "" : result.min_quote_investment || "";
            const parseMin = new trade_utils_lib_1.SafeDecimal(min).mul(1.05);
            const precision = isBase ? symbol.amount : symbol.precision;
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(parseMin, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        }));
    },
    /// 远程检测开单是否可以成功
    checkCreateOrderByRemote(requst, symbol, market, api, fee) {
        const checkRequest = {
            bu_order_type: requst.type,
            base_total_investment: requst.base_total_investment,
            quote_total_investment: requst.quote_total_investment,
            market: market,
            top: requst.top,
            bottom: requst.bottom,
            row: new trade_utils_lib_1.SafeDecimal(requst.row).toString(),
            earn_coin: requst.earn_coin,
            trend: requst.trend,
            grid_type: requst.grid_type,
            loss_stop: requst.loss_stop,
            profit_stop: requst.profit_stop,
            symbol: symbol,
            leverage: requst.leverage,
            per_volume: requst.per_volume,
            open_price: requst.open_price,
            condition: requst.condition,
            condition_direction: requst.condition_direction,
            fee_rate: fee,
        };
        return api.checkGridOrderCanCreate(checkRequest);
    },
    getConditionDirectionWithFormatterError(condition, currentPrice, str) {
        if (!condition) {
            return undefined;
        }
        if (!currentPrice) {
            throw str("trade_query_ticker_error");
        }
        return this.getConditionDirection(condition, currentPrice);
    },
    getConditionDirection(condition, currentPrice) {
        if (!condition) {
            return undefined;
        }
        if (new trade_utils_lib_1.SafeDecimal(condition).greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(currentPrice))) {
            return "1";
        }
        else {
            return "-1";
        }
    },
    /**
     * 止盈止损相关信息输入校验
     * @param trend
     * @param openPrice
     * @param openPriceType
     * @param top
     * @param bottom
     * @param $st
     * @param takeProfit
     * @param stopLost
     */
    checkTakeProfitAndStopLost(trend, openPrice, openPriceType, top, bottom, $st, takeProfit, stopLost) {
        const price = new trade_utils_lib_1.SafeDecimal(openPrice);
        const _top = new trade_utils_lib_1.SafeDecimal(top);
        const _bottom = new trade_utils_lib_1.SafeDecimal(bottom);
        if (trend === "long") {
            // 看多状态下 止盈 > top > bottom > 止损
            // 止损 < openPrice
            // 止盈 > openPrice
            if (takeProfit) {
                if (new trade_utils_lib_1.SafeDecimal(takeProfit).lessThanOrEqualTo(_top)) {
                    throw $st("grid_bullish_take_profit_error");
                }
            }
            if (stopLost) {
                if (new trade_utils_lib_1.SafeDecimal(stopLost).greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(_bottom))) {
                    throw $st("grid_bullish_stop_loss_error");
                }
            }
        }
        else {
            // 看空状态下 止损 > top > bottom > 止盈
            // 止盈 < openPrice
            // 止损 > openPrice
            if (takeProfit) {
                if (new trade_utils_lib_1.SafeDecimal(takeProfit).greaterThanOrEqualTo(_bottom)) {
                    throw $st("grid_bealish_take_profit_error");
                }
            }
            if (stopLost) {
                if (new trade_utils_lib_1.SafeDecimal(stopLost).lessThanOrEqualTo(_top)) {
                    throw $st("grid_bealish_stop_loss_error");
                }
            }
        }
        this.checkTakeProfitAndStopLostForRunningOrder(trend, openPrice.toString(), $st, takeProfit, stopLost, openPriceType);
    },
    /**
     * 修改运行中的订单价格，限制条件剔除最高最低价
     */
    checkTakeProfitAndStopLostForRunningOrder(trend, openPrice, $st, takeProfit, stopLost, openPriceType) {
        const price = new trade_utils_lib_1.SafeDecimal(openPrice);
        if (trend === "long") {
            // 止损 < openPrice
            // 止盈 > openPrice
            if (takeProfit) {
                if (new trade_utils_lib_1.SafeDecimal(takeProfit).lessThanOrEqualTo(price)) {
                    if (openPriceType === "currentPrice") {
                        throw $st("grid_bullish_take_profit_error_2");
                    }
                    if (openPriceType === "conditionPrice") {
                        throw $st("grid_bullish_take_profit_error_3");
                    }
                    throw $st("grid_bullish_take_profit_error_current_price");
                }
            }
            if (stopLost) {
                if (new trade_utils_lib_1.SafeDecimal(stopLost).greaterThanOrEqualTo(price)) {
                    if (openPriceType === "currentPrice") {
                        throw $st("grid_bullish_stop_loss_error_2");
                    }
                    if (openPriceType === "conditionPrice") {
                        throw $st("grid_bullish_stop_loss_error_3");
                    }
                    throw $st("grid_bullish_stop_loss_error_current_price");
                }
            }
        }
        else {
            // 止盈 < openPrice
            // 止损 > openPrice
            if (takeProfit) {
                if (new trade_utils_lib_1.SafeDecimal(takeProfit).greaterThanOrEqualTo(price)) {
                    if (openPriceType === "currentPrice") {
                        throw $st("grid_bullish_take_profit_error_4");
                    }
                    if (openPriceType === "conditionPrice") {
                        throw $st("grid_bullish_take_profit_error_5");
                    }
                    throw $st("grid_bealish_take_profit_error_current_price");
                }
            }
            if (stopLost) {
                if (new trade_utils_lib_1.SafeDecimal(stopLost).lessThanOrEqualTo(price)) {
                    if (openPriceType === "currentPrice") {
                        throw $st("grid_bullish_stop_loss_error_4");
                    }
                    if (openPriceType === "conditionPrice") {
                        throw $st("grid_bullish_stop_loss_error_5");
                    }
                    throw $st("grid_bealish_stop_loss_error_current_price");
                }
            }
        }
    },
    // 本地检查开单参数, 正确返回开单数据结构, 错误抛出.
    checkCommonParamsByLocal(input, $st) {
        const openPrice = new trade_utils_lib_1.SafeDecimal(input.triggerPrice || input.currentPrice);
        const openPriceType = new trade_utils_lib_1.SafeDecimal(input.triggerPrice).equals(0) ? "currentPrice" : "conditionPrice";
        if (input.emptyErrors.length > 0) {
            throw $st("trade_params_not_fill_enough");
        }
        if (!input.currentPrice) {
            throw $st("trade_query_ticker_error");
        }
        if (input.feeError) {
            throw $st("trade_error_query_fee", { error: input.feeError });
        }
        // 1.网格数量是否合规
        const grids = input.count ? Number(input.count) || 0 : 0;
        if (input.realMaxGrids < 2) {
            throw $st("grid_error_range_too_small");
        }
        if (input.botType === TradeAPILib_1.ExchangeOrderType.gridV3 || input.botType === TradeAPILib_1.ExchangeOrderType.gridV4) {
            const maxCount = input.maxGrids || 1000;
            if (grids < 2 || grids > maxCount) {
                throw $st("grid_count_range_wrong", { min: 2, max: maxCount });
            }
            else if (grids > input.realMaxGrids) {
                throw $st("grid_error_grid_too_more", { max: input.realMaxGrids });
            }
        }
        else {
            if (grids < 2 || grids > 150) {
                throw $st("grid_row_wrong");
            }
            else if (grids > input.realMaxGrids) {
                throw $st("grid_error_grid_too_more", { max: input.realMaxGrids });
            }
        }
        // 2.判断价格顺序
        if (new trade_utils_lib_1.SafeDecimal(input.bottom).greaterThanOrEqualTo(new trade_utils_lib_1.SafeDecimal(input.top))) {
            throw $st("gird_price_range_error");
        }
        if (Number(input.bottom) <= 0 || Number(input.top) <= 0 || Number(input.count) <= 0 || Number(input.invest) <= 0) {
            throw $st("gird_params_need_great_than_zero");
        }
        // 判断止盈止损价格顺序
        this.checkTakeProfitAndStopLost(input.trend, openPrice.toString(), openPriceType, input.top, input.bottom, $st, input.takeProfitPrice, input.stopLostPrice);
        if (Number(input.triggerPrice)) {
            const cur = new trade_utils_lib_1.SafeDecimal(input.currentPrice);
            const tri = new trade_utils_lib_1.SafeDecimal(input.triggerPrice);
            const warningBar = 0.0005;
            const rateStr = trade_utils_lib_1.NumberCommonUtils.toPercent(new trade_utils_lib_1.SafeDecimal(warningBar).mul(100), false, true);
            if (tri.greaterThanOrEqualTo(cur)) {
                // 当触发价大于等于现价
                const min = cur.mul(1 + warningBar);
                if (tri.lessThanOrEqualTo(min)) {
                    // 需要大于现价的warningBar
                    throw $st("trade_error_condition_need_greater_than", {
                        rate: rateStr,
                    });
                }
            }
            else {
                // 当触发价低于现价
                const max = cur.mul(1 - warningBar);
                if (tri.greaterThanOrEqualTo(max)) {
                    // 需要小于现价的warningBar
                    throw $st("trade_error_condition_need_less_than", { rate: rateStr });
                }
            }
        }
        // 3.判断是否大于最小开单金额
        if (input.minInvest && new trade_utils_lib_1.SafeDecimal(input.invest).lessThan(new trade_utils_lib_1.SafeDecimal(input.minInvest))) {
            if (input.earnCoin === input.symbol.base) {
                throw $st("trade_error_low_amount", {
                    amount: `${input.minInvest} ${input.earnCoinDisplay}`,
                });
            }
            else {
                throw $st("trade_error_low_cost", {
                    cost: `${input.minInvest} ${input.earnCoinDisplay}`,
                });
            }
        }
        const investPercent = new trade_utils_lib_1.SafeDecimal(input.invest).div(new trade_utils_lib_1.SafeDecimal(input.totalAvailable));
        // 4.判断余额是否足够
        if (investPercent.greaterThan(1)) {
            throw $st("trade_error_balance_not_enough");
        }
        // 6.单网格利润是否低于0
        if (input.profitPerGrid) {
            for (const item of input.profitPerGrid) {
                if (new trade_utils_lib_1.SafeDecimal(item).lessThanOrEqualTo(0)) {
                    throw $st("grid_error_profit_per_grid_is_zero");
                }
            }
        }
        return this.convertToGridProRequestParams(input);
    },
    /**
     * 将本地定义的verify_order参数转换为服务端定义的参数。
     * @param input
     */
    convertToGridProRequestParams(input) {
        // 2.1判断触发价逻辑
        const conditionDirection = this.getConditionDirection(input.triggerPrice, input.currentPrice);
        // 5.设置开单价格的阈值
        const [open_position_buy_limit, open_position_sell_limit] = (0, exports.GridCheckOpenPositionPriceLimit)(input.openPriceLimit, input.triggerPrice, input.currentPrice, input.useAllCoins, input.trend, input.symbol);
        const base_total_investment = input.earnCoin === input.symbol.base ? input.invest : "0";
        const quote_total_investment = input.earnCoin === input.symbol.quote ? input.invest : "0";
        return {
            base: input.symbol.base,
            quote: input.symbol.quote,
            type: input.botType,
            top: input.top,
            bottom: input.bottom,
            row: input.count ? Number(input.count) || 0 : 0,
            grid_type: input.gridType,
            earn_coin: input.earnCoin,
            trend: input.trend,
            base_total_investment: base_total_investment,
            quote_total_investment: quote_total_investment,
            loss_stop: input.stopLostPrice,
            profit_stop: input.takeProfitPrice,
            condition: input.triggerPrice,
            condition_direction: conditionDirection,
            open_position_buy_limit: open_position_buy_limit,
            open_position_sell_limit: open_position_sell_limit,
            open_price: input.currentPrice,
            leverage: "1",
        };
    },
    // type只对pionex有用
    queryFeeRate(base, quote, api, market, type) {
        let ob;
        if (market.toLocaleLowerCase() === "pionex.v2") {
            ob = api.queryPionexFeeRate(base, quote).pipe((0, operators_1.map)((data) => {
                if (type === "maker") {
                    return new trade_utils_lib_1.SafeDecimal(data.makerFeeRate).toString();
                }
                else {
                    return new trade_utils_lib_1.SafeDecimal(data.takerFeeRate).toString();
                }
            }));
        }
        else {
            ob = api.queryExchangeFeeRate(market, `${base}/${quote}`);
        }
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return ob;
        }, { maxRetryCount: 2, name: "queryFeeRate_trade_lib_wrapper" });
    },
    useFeeRate(symbol, api, market, type = "maker") {
        const [fee, setFee] = (0, react_1.useState)("");
        const [error, setError] = (0, react_1.useState)("not back");
        (0, react_1.useEffect)(() => {
            setError("not back");
            if (symbol === undefined) {
                return;
            }
            const subscribe = this.queryFeeRate(symbol.base, symbol.quote, api, market, type).subscribe((data) => {
                setError("");
                setFee(data);
            }, (err) => {
                if (typeof err === "object") {
                    setError(JSON.stringify(err));
                }
                else if (typeof err === "string") {
                    setError(err);
                }
                else {
                    setError(`${err}`);
                }
            });
            return () => {
                subscribe.unsubscribe();
            };
        }, [symbol, api, market]);
        return [fee, error];
    },
    // 获取挂单价数组 结果为升序 example: 1,2,3...
    getPriceInterverArr(top, bottom, row, gridType) {
        if (!Number(top) || !Number(bottom) || !Number(row) || Number(row) < 2 || Number(top) <= Number(bottom)) {
            throw "params has wrong";
        }
        const _top = new trade_utils_lib_1.SafeDecimal(top);
        const _bottom = new trade_utils_lib_1.SafeDecimal(bottom);
        const _row = new trade_utils_lib_1.SafeDecimal(row);
        let priceArr = [];
        if (gridType === "arithmetic") {
            const _step = _top.sub(_bottom).div(_row.sub(1));
            for (let i = 0; i < (Number(row) || 0); i++) {
                const price = _bottom.add(_step.mul(i));
                priceArr.push(price);
            }
        }
        else {
            const _perProfit = (0, trade_utils_lib_1.calcProfitPerGridOnGeometric)(top, bottom, _row.toString(), "");
            const perProfit = new trade_utils_lib_1.SafeDecimal(_perProfit).add(1);
            for (let i = 0; i < (Number(row) || 0); i++) {
                const price = _bottom.mul(perProfit.pow(i));
                priceArr.push(price);
            }
        }
        priceArr[priceArr.length - 1] = _top;
        return priceArr;
    },
    // 查询价格所在数组中的区域下标
    findPriceIndexInArr(arr, price) {
        const priceDecimal = new trade_utils_lib_1.SafeDecimal(price);
        let index = arr.length - 1;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].greaterThanOrEqualTo(priceDecimal)) {
                if (i <= 0) {
                    index = i;
                }
                else {
                    index = arr[i].sub(priceDecimal).lessThanOrEqualTo(priceDecimal.sub(arr[i - 1])) ? i : i - 1;
                }
                break;
            }
        }
        return index;
    },
    // 获取单网格交易量
    getPerGridValume(top, bottom, row, baseInvest, quoteInvest, currentPrice, gridType, trend) {
        if (!Number(top) || !Number(bottom) || !Number(row) || Number(row) < 2 || Number(top) <= Number(bottom)) {
            return 0;
        }
        const priceArr = this.getPriceInterverArr(top, bottom, row, gridType);
        // 当前价格所在数组的下标
        const curPriceIndex = this.findPriceIndexInArr(priceArr, currentPrice);
        let sumPrice = new trade_utils_lib_1.SafeDecimal(0); // 当前价格向下的格子挂买单的格子的价格总和
        for (let i = 0; i < curPriceIndex; i++) {
            sumPrice = sumPrice.add(priceArr[i]);
        }
        const curPrice = new trade_utils_lib_1.SafeDecimal(currentPrice);
        if (trend === "long") {
            // 做多, 主投quote
            // baseAmount * currentPrice + quoteAmount = (buyOrderPriceSum * x + sellOrderCount * currentPrice * x)
            // (base * 当前价 + quote) / ((当前价格向上的格子挂卖单, 用当前价格) + (当前价格向下的格子挂买单, 用格子的价格))
            const result = new trade_utils_lib_1.SafeDecimal(baseInvest)
                .mul(curPrice)
                .add(new trade_utils_lib_1.SafeDecimal(quoteInvest)) //总投资
                .div(new trade_utils_lib_1.SafeDecimal(sumPrice).add(curPrice.mul(new trade_utils_lib_1.SafeDecimal(priceArr.length - 1).sub(curPriceIndex))));
            return result.toNumber();
        }
        else {
            // 做空, 主投base
            // baseAmount + quoteAmount / currentPrice = buyOrderPriceSum * x / currentPrice + sellOrderCount * x
            // (base + quote / 当前价) * currentPrice / (buyOrderPriceSum + sellOrderCount * currentPrice)
            const result = new trade_utils_lib_1.SafeDecimal(baseInvest)
                .add(new trade_utils_lib_1.SafeDecimal(quoteInvest).div(curPrice))
                .mul(curPrice)
                .div(new trade_utils_lib_1.SafeDecimal(sumPrice).add(new trade_utils_lib_1.SafeDecimal(priceArr.length - 1).sub(curPriceIndex).mul(curPrice)));
            return result.toNumber();
        }
    },
    // loanAmount 为借出的数量, 做空时单位为base, 做多时单位为quote
    calculateLiquidationPrice(top, bottom, row, liquidationBar, trend, perVolume, loanAmount, gridType, symbol, baseDeposit, quoteDeposit) {
        if (!Number(top) || !Number(bottom) || !Number(row) || Number(row) < 2 || Number(top) <= Number(bottom)) {
            return "";
        }
        if (!Number(loanAmount)) {
            return "";
        }
        // 获取强平价
        const getLiquidationPrice = (baseAmount, quoteAmount, trend, loanAmount, liquidationBar) => {
            // 强平数量 loan * liquidationBar
            const liquidationAmount = new trade_utils_lib_1.SafeDecimal(loanAmount).mul(new trade_utils_lib_1.SafeDecimal(liquidationBar));
            if (trend === "short") {
                // 借base : base + quote / x = liquidationAmount
                const r = new trade_utils_lib_1.SafeDecimal(quoteAmount).div(liquidationAmount.sub(new trade_utils_lib_1.SafeDecimal(baseAmount))).toString();
                return r;
            }
            else {
                // 借quote : base * x + quote = liquidationAmount
                const r = liquidationAmount.sub(new trade_utils_lib_1.SafeDecimal(quoteAmount)).div(new trade_utils_lib_1.SafeDecimal(baseAmount)).toString();
                return r;
            }
        };
        // 挂单价数组
        const priceArr = this.getPriceInterverArr(top, bottom, row, gridType);
        if (trend === "long") {
            let quoteAmount = new trade_utils_lib_1.SafeDecimal(0);
            for (let i = 0; i < priceArr.length; i++) {
                const price = priceArr[i];
                const baseAmount = new trade_utils_lib_1.SafeDecimal(perVolume).mul(new trade_utils_lib_1.SafeDecimal(row).sub(1).sub(i));
                if (i > 0) {
                    quoteAmount = quoteAmount.add(new trade_utils_lib_1.SafeDecimal(priceArr[i - 1]).mul(new trade_utils_lib_1.SafeDecimal(perVolume)));
                }
                // 加上保证金
                const allBase = new trade_utils_lib_1.SafeDecimal(baseDeposit).add(baseAmount).toString();
                const allQuote = new trade_utils_lib_1.SafeDecimal(quoteDeposit).add(quoteAmount).toString();
                const result = getLiquidationPrice(allBase, allQuote, trend, loanAmount, liquidationBar);
                const curBottom = new trade_utils_lib_1.SafeDecimal(price);
                if (new trade_utils_lib_1.SafeDecimal(result).lessThanOrEqualTo(curBottom)) {
                    return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
                }
            }
            quoteAmount = quoteAmount.add(new trade_utils_lib_1.SafeDecimal(priceArr[priceArr.length - 1]).mul(new trade_utils_lib_1.SafeDecimal(perVolume)));
            const allQuote = quoteAmount.add(new trade_utils_lib_1.SafeDecimal(quoteDeposit)).toString();
            const result = getLiquidationPrice("0", allQuote, trend, loanAmount, liquidationBar);
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
        }
        else {
            // 从高点开始
            for (let i = priceArr.length - 1; i >= 0; i--) {
                // 当前价格以下的quote数量
                let sumPrice = new trade_utils_lib_1.SafeDecimal(0);
                for (let j = 0; j < i; j++) {
                    sumPrice = sumPrice.add(priceArr[j]);
                }
                const curTop = priceArr[i];
                const quoteAmount = sumPrice.mul(new trade_utils_lib_1.SafeDecimal(perVolume));
                const baseAmount = new trade_utils_lib_1.SafeDecimal(perVolume).mul(priceArr.length - 1 - i);
                const allBase = new trade_utils_lib_1.SafeDecimal(baseDeposit).add(baseAmount).toString();
                const allQuote = new trade_utils_lib_1.SafeDecimal(quoteDeposit).add(quoteAmount).toString();
                const result = getLiquidationPrice(allBase, allQuote, trend, loanAmount, liquidationBar);
                if (new trade_utils_lib_1.SafeDecimal(result).greaterThanOrEqualTo(curTop) || i === 0) {
                    return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
                }
            }
            // 当上边循环到0时已经返回最后的值了, 这里的返回值只是为了编译
            return "";
            // let quoteAmount = new SafeDecimal(0);
            // for (let i = 0; i < priceArr.length; i++) {
            //   const price = priceArr[i];
            //   quoteAmount = quoteAmount.add(new SafeDecimal(price).mul(new SafeDecimal(perVolume)));
            // }
            // const allBase = new SafeDecimal(baseDeposit).add(0).toString()
            // const allQuote = new SafeDecimal(quoteDeposit).add(quoteAmount).toString()
            // const result = getLiquidationPrice(allBase, allQuote, trend, loanAmount, liquidationBar)
            // if (new SafeDecimal(result).greaterThanOrEqualTo(new SafeDecimal(top))) {
            //   return NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
            // }
            // for (let i = 0; i < priceArr.length - 1; i++) {
            //   // 从top开始
            //   const price = priceArr[priceArr.length - 1 - i];
            //   quoteAmount = quoteAmount.sub(new SafeDecimal(price).mul(new SafeDecimal(perVolume)));
            //   const baseAmount = new SafeDecimal(perVolume).mul(new SafeDecimal(i).add(1))
            //   const allBase = new SafeDecimal(baseDeposit).add(baseAmount).toString()
            //   const allQuote = new SafeDecimal(quoteDeposit).add(quoteAmount).toString()
            //   const result = getLiquidationPrice(allBase, allQuote, trend, loanAmount, liquidationBar)
            //   if (i >= priceArr.length - 1) { // 最后一个, 最低一个
            //     return NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
            //   }
            //   const nextPrice = priceArr[priceArr.length - 2 - i];
            //   if (new SafeDecimal(result).greaterThanOrEqualTo(new SafeDecimal(nextPrice))) {
            //     return NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
            //   }
            // }
            // return NumberCommonUtils.formatterDecimalToStr(result, symbol.precision);
        }
    },
    useGirdTradeLimit(top, bottom, currentPrice, triggerPrice, symbol, api, enable = true) {
        const [limit, setLimit] = (0, react_1.useState)(undefined);
        const [maxPrice, minPrice] = (0, react_1.useMemo)(() => {
            const openPrice = triggerPrice || currentPrice;
            const topNum = Number(top) || 0;
            const bottomNum = Number(bottom) || 0;
            const priceNum = Number(openPrice) || 0;
            const max = Math.max(topNum * 2, priceNum * 2);
            const min = Math.min(bottomNum / 2, priceNum / 2);
            return [max, min];
        }, [top, bottom, triggerPrice]);
        (0, react_1.useEffect)(() => {
            if (!enable || !maxPrice || !minPrice) {
                setLimit(undefined);
                return;
            }
            const subscribe = api
                .queryTradeLimit(new trade_utils_lib_1.SafeDecimal(minPrice).toString(), new trade_utils_lib_1.SafeDecimal(maxPrice).toString(), symbol)
                .subscribe((data) => {
                setLimit(data);
            }, (error) => {
                setLimit({
                    amount: { min: null, max: null },
                    cost: { min: null, max: null },
                });
            });
            return () => {
                subscribe === null || subscribe === void 0 ? void 0 : subscribe.unsubscribe();
            };
        }, [maxPrice, minPrice, symbol.symbol, api, enable]);
        return limit;
    },
    useGirdMinPerVolume(limit) {
        return (0, react_1.useMemo)(() => {
            if (!limit) {
                return undefined;
            }
            return limit.amount.min || "";
        }, [limit]);
    },
    useGridRequireBalance(top, bottom, count, gridType, currentPrice, triggerPrice, perVolume, limit, symbol, feeRate) {
        return (0, react_1.useMemo)(() => {
            if (!limit) {
                return undefined;
            }
            const openPrice = triggerPrice || currentPrice;
            return this.calculateGridRequireBalance(top, bottom, count, gridType, openPrice, perVolume, limit, symbol, feeRate);
        }, [top, bottom, count, gridType, currentPrice, triggerPrice, perVolume, limit, symbol, feeRate]);
    },
    calculateGridRequireBalance(top, bottom, count, gridType, currentPrice, perVolume, limit, symbol, feeRate) {
        const _perVolume = Number(perVolume);
        // 检测基本参数
        if (!Number(top) || !Number(bottom) || !Number(count) || Number(count) < 2 || Number(top) <= Number(bottom) || !_perVolume) {
            return undefined;
        }
        const limitAmountMin = limit.amount.min ? Number(limit.amount.min) || 0 : 0;
        const limitCostMin = limit.cost.min ? Number(limit.cost.min) || 0 : 0;
        // 检测单网格成交量是否大于最小成交量
        if (_perVolume < limitAmountMin) {
            return undefined;
        }
        // 挂单价数组
        const priceArr = this.getPriceInterverArr(top, bottom, count, gridType);
        // 当前价格所在数组的下标
        const curPriceIndex = this.findPriceIndexInArr(priceArr, currentPrice);
        let sumPrice = new trade_utils_lib_1.SafeDecimal(0); // 当前价格向下的格子挂买单的格子的价格总和
        for (let i = 0; i < curPriceIndex; i++) {
            sumPrice = sumPrice.add(priceArr[i]);
        }
        const baseAmount = new trade_utils_lib_1.SafeDecimal(priceArr.length - 1 - curPriceIndex).mul(perVolume);
        const quoteAmount = sumPrice.mul(_perVolume);
        const feeRateDecimal = new trade_utils_lib_1.SafeDecimal(feeRate);
        //手续费池
        const basePoolValue = baseAmount.add(Number(currentPrice) ? quoteAmount.div(currentPrice) : 0).mul(feeRateDecimal);
        const baseFeePool = trade_utils_lib_1.SafeDecimal.max(basePoolValue, limitAmountMin).mul(2);
        const quotePoolValue = quoteAmount.add(baseAmount.mul(currentPrice || 0)).mul(feeRateDecimal);
        const quoteFeePool = trade_utils_lib_1.SafeDecimal.max(quotePoolValue, limitCostMin).mul(2);
        const needBase = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(baseAmount.add(baseFeePool), symbol.amount, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        const needQuote = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quoteAmount.add(quoteFeePool), symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        return { needBase, needQuote };
    },
    useGridMinAddPosition(order, symbol, open_price, tradeApi) {
        const market = order.exchange || TradeAPILib_1.ExchangeID.PIONEXV2;
        const [minAddPosition, setMinAddPosition] = (0, react_1.useState)("");
        const [fee, feeError] = exports.GridTradingUtils.useFeeRate(symbol, tradeApi, market);
        const checkRequest = (0, react_1.useMemo)(() => {
            if ((order.exchangeGridV3Order === undefined && order.exchangeGridV4Order === undefined) || symbol === undefined) {
                return undefined;
            }
            const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
            return {
                bu_order_type: order.orderType,
                symbol: symbol,
                base_total_investment: innerOrder.initBaseAmount.toString(),
                quote_total_investment: innerOrder.initQuoteAmount.toString(),
                market: market,
                top: innerOrder.high.toString(),
                bottom: innerOrder.low.toString(),
                row: innerOrder.number.toString(),
                earn_coin: innerOrder.earnCoin,
                trend: innerOrder.trend,
                grid_type: innerOrder.gridType,
                loss_stop: innerOrder.stop ? innerOrder.stop.toString() : "",
                profit_stop: innerOrder.trailing ? innerOrder.trailing.toString() : "",
                open_price: open_price,
                condition: innerOrder.condition ? innerOrder.condition.toString() : "",
                condition_direction: innerOrder.conditionDirection ? innerOrder.conditionDirection.toString() : "",
                leverage: "",
                fee_rate: fee,
            };
        }, [order, symbol, open_price]);
        (0, react_1.useEffect)(() => {
            if (checkRequest === undefined) {
                return;
            }
            const observe$ = (0, trade_utils_lib_1.requestWithRetry)(() => tradeApi.queryGridMinAddPosition(checkRequest, order.orderType), { maxRetryCount: 3 })
                .pipe((0, operators_1.map)((result) => {
                if (result.min_investment) {
                    return result.min_investment;
                }
                else {
                    return "";
                }
            }))
                .subscribe((result) => {
                setMinAddPosition(result);
            }, (error) => {
                console.log(error);
            });
            return () => {
                observe$.unsubscribe();
            };
        }, [checkRequest, order, tradeApi]);
        return minAddPosition;
    },
    calculateGridsMax(top, bottom, gridType, fee, precision) {
        if (!top || !bottom) {
            return undefined;
        }
        const topD = new trade_utils_lib_1.SafeDecimal(top);
        const bottomD = new trade_utils_lib_1.SafeDecimal(bottom);
        const feeD = new trade_utils_lib_1.SafeDecimal(fee);
        const oneD = new trade_utils_lib_1.SafeDecimal(1);
        const precisionD = new trade_utils_lib_1.SafeDecimal(precision);
        const precisionPriceMin = oneD.div(new trade_utils_lib_1.SafeDecimal(10).pow(precisionD)); // 最小精度的价格单位
        if (topD.lessThanOrEqualTo(bottomD)) {
            return undefined;
        }
        if (gridType === "geometric") {
            // 等比
            // 最小每格利润率 max(2倍手续费，符合价格精度时的最下方一格的利润率）
            const minProfit = trade_utils_lib_1.SafeDecimal.max(feeD.mul(2), bottomD.add(precisionPriceMin).div(bottomD).sub(oneD));
            // 最大网格数=log(价格上限/价格下限，1+最小每格利润率)+1
            const result = trade_utils_lib_1.SafeDecimal.log(topD.div(bottomD), oneD.add(minProfit)).add(oneD).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
            return result.toNumber();
        }
        else {
            // 等差
            // 价格间距 max（价格上限*2*手续费占比，价格精度）
            const priceInterval = trade_utils_lib_1.SafeDecimal.max(topD.mul(feeD).mul(2), precisionPriceMin);
            const result = topD.sub(bottomD).div(priceInterval).add(oneD).toDecimalPlaces(0, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
            return result.toNumber();
        }
    },
    useRealMaxGridCount(top, bottom, gridType, fee, precision, limit) {
        return (0, react_1.useMemo)(() => {
            const limitD = new trade_utils_lib_1.SafeDecimal(limit);
            const calcuValue = this.calculateGridsMax(top, bottom, gridType, fee, precision);
            if (calcuValue !== undefined && limit) {
                return trade_utils_lib_1.SafeDecimal.min(calcuValue, limitD).toNumber();
            }
            return limitD.toNumber();
        }, [top, bottom, gridType, fee, precision, limit]);
    },
};
